import React, { useEffect } from 'react';

import './styles.scss';
import { MESSAGES } from 'constants/messages';
import { useSelector } from 'react-redux';
import { getCurrentLicense } from 'store/license/getters';

const STYLES = {
  borderRadius: '5px',
  overflow: 'hidden',
  width: '845px',
  boxShadow: '0px 0px 26px 0px #232323',
}

const PricingTable = () => {
  const license = useSelector(getCurrentLicense);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/pricing-table.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="pricing-table">
      <span className="pricing-table__title">{MESSAGES.select_your_plan}</span>
      <stripe-pricing-table
        style={STYLES}   // only inline styles work in this case
        pricing-table-id={process.env.REACT_APP_STRIPE_PRICING_TABLE_ID}
        publishable-key={process.env.REACT_APP_STRIPE_PUBLIC_KEY}
        client-reference-id={license.uuid}
      />
    </div>
  );
};

export default PricingTable;
